<script>
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: "AccessRequestListItem",
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['approve', 'reject'],
  setup(props) {
    const { t } = useI18n();

    const formatDate = (dateStr) => {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleString('uk-UA', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    };

    const statusClass = computed(() => {
      switch (props.request.status) {
        case 'approved': return 'bg-success';
        case 'rejected': return 'bg-danger';
        default: return 'bg-info';
      }
    });

    const processedTextClass = computed(() => {
      switch (props.request.status) {
        case 'approved': return 'text-success';
        case 'rejected': return 'text-danger';
        default: return 'text-primary';
      }
    });

    return { t, formatDate, statusClass, processedTextClass };
  }
});
</script>

<template>
  <li class="list-group-item d-flex justify-content-between align-items-center">
    <div class="ms-2 me-auto">
      <div class="d-flex align-items-center gap-2">
        <span class="badge text-white" :class="statusClass">
          {{ t('statuses.' + request.status) }}
        </span>
        <span class="fw-bold text-primary"> {{ request.distributorId?.username || 'Unknown' }}</span>
      </div>

      <div class="mt-1">
        {{ t('labels.accessTo') }}: <strong>{{ request.clientId?.name }}</strong>
        <small class="text-muted"> ({{ request.clientId?.phone }})</small>
      </div>

      <div class="mt-1" style="font-size: 0.85em;"> <span class="text-secondary">
           <i class="bi bi-clock"></i> {{ t('labels.created') }}: {{ formatDate(request.createdAt) }}
        </span>

        <span v-if="request.status !== 'pending' && request.updatedAt" :class="processedTextClass" class="fw-bold">
            | <i class="bi bi-check-circle"></i> {{ t('labels.processed') }}: {{ formatDate(request.updatedAt) }}
        </span>
      </div>
    </div>

    <div class="d-flex gap-2" v-if="request.status === 'pending'">
      <button class="btn btn-success btn-sm text-white" @click="$emit('approve', request._id)">
        <i class="bi bi-check-lg"></i> {{ t('buttons.confirm') }}
      </button>
      <button class="btn btn-danger btn-sm" @click="$emit('reject', request._id)">
        <i class="bi bi-x-lg"></i> {{ t('buttons.cancel') }}
      </button>
    </div>
  </li>
</template>